import "./loader.css"
export default function Loader() {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="spinner"></div>
    </div>
  )
}
